import * as R from 'ramda';
import parseSaleComment from './parseSaleComment';

export default function parseSaleComments(items) {
  return R.map(parseSaleComment, items);
}
